module.exports = __webpack_public_path__ + "img/search.f31b0a0b.svg";